<!--TODO Dependency-->
<ui-object-navigation-main-page alias="tm"></ui-object-navigation-main-page>